import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {LeftOutlined} from "@ant-design/icons";
import {Button, Spin} from "antd";

import StatusForm from "../../../components/StatusForm";
import ErrorBoundary from "../../../components/ErrorBoundary";
import {messageType, showMessages} from "../../../helpers/message";
import {getCar, updateCarStatus} from "../../../helpers/car";
import {getAvailableCarStatuses} from "../../../helpers/option";

// MR Note: Read comment within the handleFinish function.
const CarEdit = () => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const location = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [car, setCar] = useState(false);
    // const [status, setStatus] = useState(false);
    const [availableStatuses, setAvailableStatues] = useState(false);

    const handleFinish = async (data) => {
        const abortSignal = abortSignalRef.current;

        try {
            // I am not sure this entire component is used anymore. There's no way to navigate to this
            // component in any capacity, it's route is /fleet/car/edit and I don't see where on the F/E we can arrive here.
            // The GitBlame mentions the "status" functionality is to make a car not visible by staff or the system.
            // I don't see that anywhere on CarManageStaff container or the F/E.
            await updateCarStatus(data, car.id, abortSignal);

            navigate('/fleet/car?id=' + car.id);

            showMessages('Car status has been updated.', messageType.success);
        } catch (error) {
            showMessages(error.message, messageType.error);
        }
    };

    useEffect(() => {
        const fetchCarAndStatuses = async () => {
            const abortSignal = abortSignalRef.current;
            const carID = new URLSearchParams(location.search).get('id');
            setLoading(true);

            try {
                const [car, availableStatuses] = await Promise.all([
                    getCar(carID, abortSignal),
                    getAvailableCarStatuses(abortSignal)
                ]);
                const availableStatusNames = availableStatuses.map((status) => {
                    return status.name;
                });

                car && setCar(car);
                availableStatusNames && setAvailableStatues(availableStatusNames);

                setLoading(false);
            } catch (error) {
                showMessages(error.message, messageType.error);
                setLoading(false);
                if(error.status_code === 404) window.location.replace('/404');
            }
        }

        fetchCarAndStatuses();
    }, [location.search])

    return (
        <Spin spinning={loading}>
            <div>
                <Button icon={<LeftOutlined/>} onClick={() => navigate(-1)}/>
                <br/>
                <br/>
                <ErrorBoundary>
                    <StatusForm
                        defaultStatus={availableStatuses[0]}
                        status={availableStatuses}
                        type="state"
                        buttonText="Update Car Status"
                        handleFinish={handleFinish}
                    />
                </ErrorBoundary>
            </div>;
        </Spin>
    )
}

export default CarEdit;

CarEdit.propTypes = {};
